<template>
  <transition name="pop">
    <div class="pop-mask">
      <div class="pop-wrapper">
        <div class="pop-container">
          <font-awesome-icon @click="$emit('close')" class="icon close-btn" size="2x" :icon="['fas', 'times']" />
          <div class="pop-body">
            <slot name="table"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PopUp',
  data () {
    return {
      // voiceUrl: ''
    }
  },
  // props: {
  //   recognize: {
  //     required: true,
  //     default: () => {
  //       return []
  //     }
  //   }
  // },
  watch: {
    // voiceUrl (val) {
    //   this.playAudio(val)
    // }
  },
  methods: {
    // async playAudio (url) {
    //   this.voiceUrl = url
    //   let dom = document.getElementById('audio')
    //   dom.load()
    //   const playPromise = dom.play()
    //   if (playPromise !== undefined) {
    //     try {
    //       await playPromise
    //     } catch (error) {
    //     }
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.pop-mask {
  text-align: left;
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .8);
  display: table;
  transition: opacity .3s ease;
  font-size: 1.25rem;
}

.pop-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.pop-container {
  width: 70%;
  margin: 0px auto;
  padding: 20px 0;
  position: relative;
  border-radius: 10px;
  transition: all .3s ease;
}

.pop-body {
  height: 70vh;
  padding: 20px;
  border-radius: 10px;
  background-color: #fff;
  margin: 20px 0;
}
.pop-default-button {
  float: right;
  background-color: #fff;
  width: 20%;
}

.pop-enter {
  opacity: 0;
}

.pop-leave-active {
  opacity: 0;
}

.pop-enter .pop-container,
.pop-leave-active .pop-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.close-btn {
  position: absolute;
  right: 5px;
  top: 50px;
  width: 40px;
  height: 40px;
  padding: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Popup.vue?73484eab